"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MoreButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _Button = _interopRequireDefault(require("../Button"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _ExcelImport = _interopRequireDefault(require("./ExcelImport"));
var _ykbUtils = require("ykb-utils");
var _StyledTableHeader = require("./StyledTableHeader");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var DropdownStyle = (0, _ykbStyledComponents.createGlobalStyle)([".table-more-dropdown{border-radius:10px;overflow:hidden;&-menu{&&{background:", ";& > .table-more-dropdown-menu-item{background:", ";color:white !important;:hover{background:", ";}&-disabled{background:", " !important;pointer-events:auto;&:hover{cursor:not-allowed;}}}}}}"], function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary7;
}, function (props) {
  return props.theme.color.primary4;
});
var DropdownButton = (0, _ykbStyledComponents.default)(_Button.default).withConfig({
  componentId: "ykb-ui__sc-uxtfdh-0"
})(["&&{padding:0px;border-radius:50%;width:30px;height:30px;text-align:center;color:", ";background-color:transparent;.text.text{margin-left:0px !important;}&[class$='-open'],:hover{color:", ";background-color:", ";}}"], function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary7;
}, function (props) {
  return props.theme.color.primary3;
});
var Toggle = (0, _ykbStyledComponents.default)(_Button.default).withConfig({
  componentId: "ykb-ui__sc-uxtfdh-1"
})(["&&{height:auto;padding:0px;text-align:center;color:", ";}.text{display:flex;align-items:center;}}svg{margin-left:5px;}"], function (props) {
  return props.theme.color.primary6;
});

// TODO add types

function MoreButton(props) {
  var _React$useState = React.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    excelModalVisible = _React$useState2[0],
    setExcelModalVisible = _React$useState2[1];
  var nodeRef = (0, _react.useRef)();
  function renderMenus(selections) {
    return selections.map(function (selection, index) {
      return /*#__PURE__*/React.createElement(_Menu.default.Item, {
        key: selection.key || index,
        disabled: selection.disabled
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          if (!selection.disabled) {
            selection.onSelect();
          }
        }
      }, selection.text));
    });
  }
  var prefixCls = props.prefixCls,
    selections = props.selections,
    _props$getPopupContai = props.getPopupContainer,
    getPopupContainer = _props$getPopupContai === void 0 ? _ykbUtils.containerChecker : _props$getPopupContai,
    excelImport = props.excelImport,
    showText = props.showText,
    size = props.size;
  var selectionPrefixCls = "".concat(prefixCls, "-selection");
  var customSelections = null;
  var newSelections = Array.isArray(selections) ? selections : [];
  if (showText) {
    // with popover and text
    var excelImportData = excelImport ? [{
      text: 'Excel Yükle',
      onSelect: function onSelect() {
        if (!excelImport.disabled) {
          setExcelModalVisible(true);
        }
      },
      disabled: excelImport.disabled
    }] : [];
    var options = [].concat((0, _toConsumableArray2.default)(newSelections), excelImportData);
    customSelections = newSelections.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Popover.default
    // overlay={menu}
    , {
      options: options,
      getPopupContainer: getPopupContainer,
      placement: "bottom"
    }, /*#__PURE__*/React.createElement(Toggle, (0, _extends2.default)({
      type: "ghost"
    }, size === 'small' && {
      size: 'xsmall'
    }), "Tablo \u0130\u015Flemleri", /*#__PURE__*/React.createElement(_StyledTableHeader.StyledGhostIcon, {
      name: "angle-down"
    })))) : null;
  } else {
    // with dropdown
    var menu = /*#__PURE__*/React.createElement(_Menu.default, {
      className: "".concat(selectionPrefixCls, "-menu"),
      selectedKeys: []
    }, renderMenus(newSelections), excelImport && /*#__PURE__*/React.createElement(_Menu.default.Item, {
      key: '_excelImport',
      disabled: excelImport.disabled
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        if (!excelImport.disabled) {
          setExcelModalVisible(true);
        }
      }
    }, "Excel Y\xFCkle")));
    customSelections = newSelections.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownStyle, null), /*#__PURE__*/React.createElement(_Dropdown.default, {
      overlay: menu,
      getPopupContainer: getPopupContainer,
      placement: "bottomRight",
      prefixCls: "table-more-dropdown"
    }, /*#__PURE__*/React.createElement(DropdownButton, {
      type: "ghost"
    }, /*#__PURE__*/React.createElement(_Icon.default, {
      name: "ellipsis-h",
      size: 24
    })))) : null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, customSelections, excelImport && /*#__PURE__*/React.createElement(_ExcelImport.default, {
    options: excelImport,
    excelModalVisible: excelModalVisible,
    setExcelModalVisible: setExcelModalVisible
  }));
}